import React from 'react'
import { Box, Grid, IconButton, Typography } from '@material-ui/core'
import { itemBoxStyle } from './file-upload-field.style'
import { PreviewFileSvg, RemoveSvg } from '~/components/icons'
import { convertFileNameEllipsis, convertFileSize } from '~/common/helpers'
import { FIELD_MODE } from '~/common/constants'

function UploadListPdf(props) {
	const isRenderEdit = props.mode === FIELD_MODE.edit || (props.mode === FIELD_MODE.viewDisable && props?.item.hasOwnProperty('signedBlobId'))

	const handleClick = async (e) => {
		e.preventDefault()

		if (props.onRefreshFileUrl) {
			const updatedFile = await props.onRefreshFileUrl(props.item)
			if (updatedFile) {
				props.onClick(updatedFile)
				return
			}
		}

		props.onClick(props.item)
	}

	return (
		<Grid item xs={12} sm={6}>
			<Box css={itemBoxStyle} onClick={handleClick}>
				<Box className="preview-icon">
					<PreviewFileSvg />
				</Box>
				<Box className="file">
					<Typography className="file__name">{convertFileNameEllipsis(props.item?.filename)}</Typography>
					<Typography className="file__size">{convertFileSize(props.item?.byteSize)}</Typography>
				</Box>
				{isRenderEdit && !props.hideDelete && (
					<IconButton className="removeIcon" size="small" onClick={props.onClick1}>
						<RemoveSvg />
					</IconButton>
				)}
			</Box>
		</Grid>
	)
}

export default UploadListPdf
